import { FormlyFieldConfig } from "@ngx-formly/core";
import { OccupazioneManifestazioneStep } from "./steps/occupazione-manifestazione.step";
import { RichiestaOccupazioneStep } from "../shared/richiesta-occupazione.step";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { UbicazioneStep } from "../shared/ubicazione.step";
import { IntestatarioTipo } from "app/forms/shared/intestatario.tipo";
import { AllegatiManifestazioneStep } from "./steps/allegati-manifestazione.step";

export const Manifestazione : FormlyFieldConfig[] =[
        {
            props: {
                slabel: "PRIVACY",
                label: "INFORMATIVA SULLA PRIVACY"
            },
            wrappers: ['panel-step'],
            fieldGroup: PrivacyDelegaStep
        },
        {
            props: {
                slabel: "INTESTATARIO",
                label: "DATI ANAGRAFICI INTESTATARIO"
            },
            wrappers: ['panel-step'],
            fieldGroup: [...IntestatarioTipo, ...IntestatarioStep, ...GiuridicaStep]
        },
        {
            props: {
                slabel: "UBICAZIONE",
                label: "UBICAZIONE DEL CANTIERE IN MAPPA",
            },
            wrappers: ['panel-step'],
            fieldGroup: UbicazioneStep
        },
      {
        props: {
          slabel: 'RICHIESTA',
          label: 'DATI DELLA RICHIESTA'
        },
        wrappers: ['panel-step'],
        fieldGroup: RichiestaOccupazioneStep
      },
      {
        props: {
          slabel: 'OCCUPAZIONE',
          label: 'ELEMENTI DI OCCUPAZIONE SUOLO PER MANIFESTAZIONE'
        },
        wrappers: ['panel-step'],
        fieldGroup: OccupazioneManifestazioneStep
      },
      {
        props: {
          slabel: 'ALLEGATI',
          label: 'DOCUMENTAZIONE ALLEGATA'
        },
        wrappers: ['panel-step'],
        fieldGroup: AllegatiManifestazioneStep
      },
    ]
